<div class="container-fluid h-100 p-0">
  <div class="row g-0 column-full-height property-background__dark">
    <div class="col d-flex flex-column property-background__light login-wrapper">
      <div class="h1 mt-5 text-center">Welcome to Realist</div>
      <div class="row align-items-center g-0 h-100">
        <form class="needs-validation col-xl-6 col-md-10 m-auto"
              [formGroup]="loginForm"
              (ngSubmit)="logIn()"
              autocomplete="off"
              novalidate>
          <fieldset>
            <label for="realist-username">Username*</label>
            <input id="realist-username" formControlName="username" type="text" class="form-control" maxlength="255"
                   aria-required="true"
                   required>
            <div class="invalid-feedback">
              <div *ngIf="usernameControl.hasError('required')">
                Username is required
              </div>
              <div *ngIf="usernameControl.hasError('loginError')">
                {{ usernameControl.getError('loginError') }}
              </div>
            </div>
          </fieldset>
          <fieldset>
            <label for="realist-password">Password*</label>
            <input id="realist-password" formControlName="password" type="password" class="form-control" maxlength="255"
                   aria-required="true"
                   required>
            <div class="invalid-feedback">
              <div *ngIf="passwordControl.hasError('required')">
                Password is required
              </div>
              <div *ngIf="passwordControl.hasError('loginError')">
                {{ passwordControl.getError('loginError') }}
              </div>
            </div>
          </fieldset>
          <fieldset>
            <label for="mls-group">MLS Group*</label>
            <input id="mls-group" formControlName="mlsGroup" type="text" class="form-control" maxlength="255"
                   aria-required="true"
                   required>
            <div class="invalid-feedback">
              <div *ngIf="mlsGroupControl.hasError('required')">
                MLS Group is required
              </div>
              <div *ngIf="mlsGroupControl.hasError('loginError')">
                {{ mlsGroupControl.getError('loginError') }}
              </div>
            </div>
          </fieldset>

          <button class="btn-custom btn-custom-dark btn-block mt-5"
                  type="submit"
                  [disabled]="loginForm.invalid"
                  disabled>Login</button>
        </form>
      </div>
    </div>
    <div class="flex-column col d-none d-md-block"></div>
  </div>
</div>
